var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.placeholder ? _c("div", { staticClass: "placeholder" }) : _vm._e(),
    _c(
      "div",
      {
        staticClass: "header flex-center fixed",
        style: {
          background: _vm.placeholder
            ? "rgba(255, 255, 255, 1)"
            : "transparent",
        },
        attrs: { id: "header" },
      },
      [
        _c("div", { staticClass: "v-page-center flex-between-center" }, [
          _c("div", { staticClass: "flex-between-center" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "tabs" },
              [
                _c(
                  "a-tabs",
                  {
                    attrs: { animated: false, tabBarStyle: _vm.tabBarStyle },
                    on: { change: _vm.changeTabs },
                    model: {
                      value: _vm.currTab,
                      callback: function ($$v) {
                        _vm.currTab = $$v
                      },
                      expression: "currTab",
                    },
                  },
                  _vm._l(_vm.tabs, function (tab) {
                    return _c("a-tab-pane", {
                      key: tab.key,
                      attrs: { tab: tab.name },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "login flex-between-center" }, [
            _c("div", { staticClass: "ai", on: { click: _vm.loginAI } }, [
              _vm._v(_vm._s(_vm.headerBtns.ai)),
            ]),
            _c("div", { staticClass: "saas", on: { click: _vm.loginSaas } }, [
              _vm._v(_vm._s(_vm.headerBtns.saas)),
            ]),
            _c("div", { staticClass: "trial", on: { click: _vm.useNow } }, [
              _vm._v(_vm._s(_vm.headerBtns.reg)),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: { src: require("@/assets/image/header-logo.png"), alt: "logo" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }